<template>
  <div class="commodity-all" :style="commodityH5Styl">
    <component
      ref="commodityItem"
      :is="componentTemp"
      :courseGoods="courseGoods"
      v-if="!showPlacehold"
      @detail="handleOpenDetial"
      @list="handleOpenList"
      :goodsList="goodsItemList"
      :style="{ background: courseGoods.blockBGClolor ? courseGoods.blockBGClolor : '',}"/>
    <img
      src="https://hrss-pro.oss-cn-beijing.aliyuncs.com/hrss/image/2022/06/1654845684467.png"
      alt="占位图"
      class="lacehold-img-h5"
      v-else
    >
  </div>
</template>

<script>
import goodsCommon from '../mixins/goodsCommon';
export default {
  name: 'courseGoodsH5',
  mixins: [goodsCommon],
  props:{
    data:{
      type: [Object, Array],
      default: ()=>{}
    }
  },
  computed: {
    commodityH5Styl() {
      const { tempData: { courseGoods } } = this.data;
      return {
        marginTop: courseGoods && courseGoods.blockMargeTop ? courseGoods.blockMargeTop + 'px' : 0,
        marginBottom: courseGoods && courseGoods.blockMargeBottom ? courseGoods.blockMargeBottom + 'px': 0
      }
    },
  },
  data(){
    const { blockInstanceId ,tempData: { courseGoods } } = this.data;
    let branchId = localStorage.getItem('branchId');
    let saasId = localStorage.getItem('saasId');
    return {
      showPlacehold: false,
      goodsData: this.data,
      componentTemp: '',
      branchId,
      saasId,
      courseGoods: courseGoods,
      blockInstanceId: blockInstanceId,
      goodsItemList: []
    }
  },
  created() {
    console.log(this.data,'courseGoodsH5');
    let { tempData: { courseGoods } } = this.data;
    if (!courseGoods) {
      this.showPlacehold = true;
      return
    }
    console.log('courseGoodsH5',this.data.blockInstanceId);
    this.changeModularFn();
    if (!this.branchId || this.branchId == -1 || this.branchId == null) return;
    this.goodsItemList = [];
    if (courseGoods.contentSource !== '1') {
      // 选择分类 选择全部
      this.getDataList()
    } else {
      this.getFreeList(courseGoods.goodsList,courseGoods.goodsType,courseGoods.showTotal,101)
    }
  },
  methods:{
    changeModularFn(){
      let { templateType } = this.courseGoods;  // 模板组合
      const activeUrl = {
        1: 'commodityOne',
        2: 'commodityTwo',
        3: 'commodityThree',
      }
      if (Number(templateType)) {
        if (Object.prototype.hasOwnProperty.call(activeUrl, templateType)){
          import(`./commodityComponent/${activeUrl[templateType]}`).then((module) => {
            this.componentTemp = Object.assign({},module.default)  
          })
        }
      }
    },
    getFreeList(goodsList, goodsType, showTotal, max) {
      if (!goodsList.length) {
        this.goodsItemList = [];
        return;
      }
      showTotal = showTotal ? showTotal : max-1;
      let size = showTotal < max || showTotal === 0 ? showTotal : max -1;
      let ids = goodsList.map(item => {
        return item.id
      })
      let idsOne = [];
      let idsTwo = [];
      let idsThree = [];
      goodsList.forEach(item => {
        if (item.goodsKinds == 1) {
          idsOne.push(item.id)
        } else if (item.goodsKinds == 2) {
          idsTwo.push(item.id)
        } else if (item.goodsKinds == 3){
          idsThree.push(item.id)
        }
      })
      let data = {
        branchId: this.branchId,
        saasId: this.saasId,
        list: [
          {
            goodsKinds: 1, // 自建培训
            ids: idsOne,
          },
          {
            goodsKinds: 2, // 分销
            ids: idsTwo,
          },
          {
            goodsKinds: 3, // 自建实物
            ids: idsThree,
          }
        ],
      }
      this.$apis.news.getFreeGoodsList(data).then((res) => {
        if (res.success) {
          let list = this.filterPrice(res.data,ids);
          this.goodsItemList = list.splice(0,size);
          this.$forceUpdate()
        }
      })
    },
    // filterPrice(list) {
    //   if (list.length) {
    //     list.map(item => {
    //       item.price = item.isFree == 1 ? 0 : item.price;
    //       if (item.price instanceof Number) {
    //         item.price = item.price.toFixed(2);
    //       }
    //     })
    //   }
    //   return list
    // },
    async getDataList(){
      let {
        showTotal,
        contentSource,
        commendsRule,
        code,
        articleClassID,
        goodsSelectType
      } = this.courseGoods;
      let data = {
        branchId: this.branchId,
        saasId: this.saasId,
        categoryCode: contentSource === '3' ? '' : code,
        categoryId: contentSource === '3' ? '' : articleClassID,
        name: '',
        type: commendsRule ? commendsRule : 3,
        goodsKinds: goodsSelectType
      }
      showTotal = showTotal ? showTotal : 100
      let params = {
        pageNum: 1,
        pageSize: showTotal < 101 || showTotal === 0 ? showTotal : 100
      }
      try {
        let res = await this.$apis.news.getChannelGoodsList(data,params);
        if (res.success) {
          this.goodsItemList = this.filterPrice(res.data.list);
          this.$forceUpdate()
        }
      } catch(e) {
        console.log(e)
      }
    },
    // 跳转商品详情
    handleOpenDetial(data) {
      this.openH5GoodsDetail(data);
    },
    // 跳转商品列表
    handleOpenList () {
      let {
        contentSource,
        code,
        articleClassID,
        goodsSelectType,
        goodsType
      } = this.courseGoods;
      let path = ''; // 2分销培训商品
      let query = {}
      if (contentSource == 1) { // 自由选择 2分销培训商品
        if (goodsType && goodsType == 3) { // 1 培训;
          path = '/goodsList'
        } else if (goodsType && goodsType == 2){ // 2实体商品;
          path = `/entityGoodsList?branchId=${this.branchId}`
        } else { // 1分销培训商品
          path = '/distributionGoodsList';
          query = {
            categoryId: contentSource == '2' ? articleClassID : '',
            categoryCode: contentSource == '2' ? code : '',
            isH5: 1
          }
        }
      } else {
        if (goodsSelectType && goodsSelectType == 1) { // 1 普通培训商品;
          path = '/goodsList'
        } else if (goodsSelectType && goodsSelectType == 3){ // 3实体商品;
          path = `/entityGoodsList?branchId=${this.branchId}`
        } else { // 2分销培训商品
          path = '/distributionGoodsList';
          query = {
            categoryId: contentSource == '2' ? articleClassID : '',
            categoryCode: contentSource == '2' ? code : '',
            isH5: 1
          }
        }
      }
      this.$router.push({
        path: path,
        query: query
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../asset/commodity.css";
  .commodity-all{
    margin: 0 auto;
    padding: 0 30px;
    box-sizing: border-box;
  }
</style>